export const tutorGroupSessionLoading =  ({store})  => store.tutorGroupSessionReducer.loading;

export const tutorGroupSessionError =  ({store})  => store.tutorGroupSessionReducer.error;

export const tutorGroupSessionData =  ({store})  => store.tutorGroupSessionReducer.data;